"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferService = void 0;
var Transfer_1 = require("./Transfer");
var TransferService = /** @class */ (function () {
    function TransferService(apiUrl, i18nList) {
        this.chargeSortOrder = ['wagon', 'lcl', 'container-20', 'container-30', 'container-40', 'container-45', 'wab', 'swap', 'trailer-k', 'trailer-nk', 'lkw'];
        this.transfers = [];
        this.transfersOriginal = [];
        this.combinations = [];
        this.combinationsOriginal = [];
        this.locations = [];
        this.locationsGrouped = [];
        this.synonyms = {};
        this.synonymsOriginal = [];
        this.i18nStrings = {};
        this.stations = {};
        this.networkLatLngs = {};
        this.networkLatLngsContext = {};
        this.individuals = null;
        this.url = apiUrl;
        this.initI18nStrings(i18nList);
    }
    TransferService.prototype.loadNetwork = function (callback) {
        var _this = this;
        if (this.transfersOriginal.length > 0) { // Already loaded
            this.init();
            if (callback)
                callback(this.transfersOriginal);
            return;
        }
        Promise.all([
            fetch('/.rest/transnet/transfers?lang=' + this.locale),
            fetch('/.rest/transnet/combinations?lang=' + this.locale),
            fetch('/.rest/transnet/synonyms?lang=' + this.locale),
            fetch('/.rest/transnet/locations?lang=' + this.locale),
        ])
            .then(function (results) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(results.map(function (res) { return res.json(); }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); }).then(function (results) {
            _this.transfers = results[0];
            _this.transfersOriginal = results[0];
            _this.combinations = results[1];
            _this.combinationsOriginal = results[1];
            _this.synonymsOriginal = results[2];
            _this.locations = results[3];
            _this.init();
            if (callback)
                callback();
        });
    };
    // public loadLocations(callback?: Function) {
    // 	if (this.locations.length > 0) {
    // 		if (callback) callback();
    // 		return;
    // 	}
    // 	fetch('/.rest/transnet/locations?lang=' + this.locale)
    // 		.then((result) => {
    // 			return result.json();
    // 		})
    // 		.then((locations) => {
    // 			this.locations = locations;
    // 			this.init();
    // 			if (callback) callback();
    // 		});
    // }
    TransferService.prototype.init = function () {
        var _this = this;
        var _a, _b;
        this.stations = {};
        this.networkLatLngs = {};
        this.networkLatLngsContext = {};
        this.locationsGrouped = [];
        // Transform synonyms
        if (Object.keys(this.synonyms).length === 0) {
            for (var _i = 0, _c = this.synonymsOriginal; _i < _c.length; _i++) {
                var synonym = _c[_i];
                if (synonym.synonyms.length != 0) {
                    this.synonyms[synonym.title] = synonym.synonyms;
                }
            }
        }
        // Remove transfers with name "individual" and store in separte array
        if (!this.individuals) {
            this.individuals = [];
            var i = this.transfers.length;
            while (i--) {
                if (this.transfers[i].name == Transfer_1.individual) {
                    this.individuals.push(this.transfers[i]);
                    this.transfers.splice(i, 1);
                }
            }
        }
        // Prepare stations and network points
        if (Object.keys(this.stations).length === 0
            || Object.keys(this.networkLatLngs).length === 0
            || Object.keys(this.networkLatLngsContext).length === 0) {
            for (var _d = 0, _e = this.transfers; _d < _e.length; _d++) {
                var transfer = _e[_d];
                var network = transfer.network;
                var networks = transfer.networks;
                var route = [];
                if (!this.stations[network])
                    this.stations[network] = [];
                if (!this.networkLatLngs[network])
                    this.networkLatLngs[network] = [];
                if (!this.networkLatLngsContext[network])
                    this.networkLatLngsContext[network] = [];
                var _loop_1 = function (waypoint) {
                    var latLng = [
                        waypoint.latitude,
                        waypoint.longitude,
                    ];
                    route.push(latLng);
                    // Main network stations
                    if (waypoint.type == Transfer_1.WaypointType.Station
                        && !(this_1.stations[network].some(function (station) { return station.title == waypoint.title; })) // Not already in stations
                    ) {
                        this_1.stations[network].push(waypoint);
                        var lastStation = this_1.stations[network][this_1.stations[network].length - 1];
                        if (this_1.synonyms[lastStation.title]) {
                            lastStation.synonyms = this_1.synonyms[lastStation.title];
                        }
                    }
                    // Sub networks stations
                    for (var _o = 0, networks_2 = networks; _o < networks_2.length; _o++) {
                        var networksNetwork = networks_2[_o];
                        if (!this_1.stations[networksNetwork])
                            this_1.stations[networksNetwork] = [];
                        if (waypoint.type == Transfer_1.WaypointType.Station
                            && !(this_1.stations[networksNetwork].some(function (station) { return station.title == waypoint.title; })) // Not already in stations
                        ) {
                            this_1.stations[networksNetwork].push(waypoint);
                        }
                    }
                };
                var this_1 = this;
                for (var _f = 0, _g = transfer.route; _f < _g.length; _f++) {
                    var waypoint = _g[_f];
                    _loop_1(waypoint);
                }
                // Main network
                this.networkLatLngs[network].push(route);
                this.networkLatLngsContext[network].push((_a = transfer.color) !== null && _a !== void 0 ? _a : null);
                // Sub networks
                for (var _h = 0, networks_1 = networks; _h < networks_1.length; _h++) {
                    var networksNetwork = networks_1[_h];
                    if (!this.networkLatLngs[networksNetwork])
                        this.networkLatLngs[networksNetwork] = [];
                    if (!this.networkLatLngsContext[networksNetwork])
                        this.networkLatLngsContext[networksNetwork] = [];
                    this.networkLatLngs[networksNetwork].push(route);
                    this.networkLatLngsContext[networksNetwork].push((_b = transfer.color) !== null && _b !== void 0 ? _b : null);
                }
            }
        }
        // Remove combinations that do not have transfers or transfers without routes
        if (this.combinations.length === 0) {
            this.combinations = __spreadArray([], this.combinationsOriginal, true);
            var j = this.combinations.length;
            while (j--) {
                for (var _j = 0, _k = this.combinations[j].transfers; _j < _k.length; _j++) {
                    var combinationTransfer = _k[_j];
                    var transfer = this.getTransfer(combinationTransfer.name);
                    if (!transfer || !transfer.route || transfer.route.length == 0) {
                        if (this.transfers.length === this.transfersOriginal.length) { // Only show warning if filters are not active
                            console.warn('One or more transfers in the combination do not exist or do not have a route, combination will be removed.', this.combinations[j]);
                        }
                        this.combinations.splice(j, 1);
                        break;
                    }
                }
            }
        }
        // Prepare locations grouped by latitude and longitude
        if (this.locationsGrouped.length === 0) {
            var _loop_2 = function (location_1) {
                var foundIndex = -1;
                for (var i = 0; i < this_2.locationsGrouped.length; i++) {
                    if (this_2.locationsGrouped[i].latitude === location_1.latitude && this_2.locationsGrouped[i].longitude === location_1.longitude) {
                        foundIndex = i;
                        break;
                    }
                }
                if (foundIndex == -1) {
                    this_2.locationsGrouped.push({
                        latitude: location_1.latitude,
                        longitude: location_1.longitude,
                        title: location_1.title,
                        locations: [location_1],
                        types: location_1.types,
                    });
                }
                else {
                    if (this_2.locationsGrouped[foundIndex].title)
                        this_2.locationsGrouped[foundIndex].title = this_2.locationsGrouped[foundIndex].title.split(' ')[0];
                    this_2.locationsGrouped[foundIndex].types = this_2.locationsGrouped[foundIndex].types.concat(location_1.types);
                    this_2.locationsGrouped[foundIndex].types = this_2.locationsGrouped[foundIndex].types.filter(function (type, index) { return _this.locationsGrouped[foundIndex].types.indexOf(type) === index; }); // Remove duplicates
                    this_2.locationsGrouped[foundIndex].locations.push(location_1);
                }
            };
            var this_2 = this;
            for (var _l = 0, _m = this.locations; _l < _m.length; _l++) {
                var location_1 = _m[_l];
                _loop_2(location_1);
            }
        }
    };
    TransferService.prototype.initI18nStrings = function (i18nList) {
        this.locale = i18nList.dataset.locale;
        var items = i18nList.children;
        for (var _i = 0, _a = Array.from(items); _i < _a.length; _i++) {
            var item = _a[_i];
            var key = item.dataset.key;
            this.i18nStrings[key] = item.textContent.trim();
        }
    };
    TransferService.prototype.filterByCharge = function (charge) {
        if (charge.length === 0) {
            this.transfers = __spreadArray([], this.transfersOriginal, true);
            this.init();
            return;
        }
        this.transfers = [];
        var _loop_3 = function (transfer) {
            if (!transfer.charge)
                return "continue"; // No charge
            if (charge.every(function (c) { return transfer.charge.indexOf(c) > -1; })) {
                this_3.transfers.push(transfer);
            }
        };
        var this_3 = this;
        for (var _i = 0, _a = this.transfersOriginal; _i < _a.length; _i++) {
            var transfer = _a[_i];
            _loop_3(transfer);
        }
        this.init();
    };
    TransferService.prototype.getTransfers = function () {
        return this.transfers;
    };
    TransferService.prototype.getTransfersGroupedByNetwork = function () {
        var transfersGrouped = {};
        transfersGrouped['all'] = this.transfers;
        for (var _i = 0, _a = this.transfers; _i < _a.length; _i++) {
            var transfer = _a[_i];
            if (!transfersGrouped[transfer.network]) {
                transfersGrouped[transfer.network] = [];
            }
            transfersGrouped[transfer.network].push(transfer);
        }
        return transfersGrouped;
    };
    TransferService.prototype.getTransfersByNetwork = function (network) {
        var transfersGrouped = this.getTransfersGroupedByNetwork();
        if (!transfersGrouped[network])
            return [];
        return transfersGrouped[network];
    };
    TransferService.prototype.getTransfersGroupedByNetworkWithoutDuplicatesByTitle = function () {
        var transfersAlreadyAdded = [];
        var transfersGrouped = { 'all': [] }; // {};
        for (var _i = 0, _a = this.transfers; _i < _a.length; _i++) {
            var transfer = _a[_i];
            if (transfersAlreadyAdded.indexOf(transfer.title) > -1)
                continue;
            if (!transfersGrouped[transfer.network])
                transfersGrouped[transfer.network] = [];
            transfersGrouped['all'].push(transfer);
            transfersGrouped[transfer.network].push(transfer);
            transfersAlreadyAdded.push(transfer.title);
        }
        return transfersGrouped;
    };
    TransferService.prototype.getStations = function (network) {
        if (network) {
            if (this.stations[network]) {
                return this.stations[network].sort(function (a, b) { return (a.title > b.title) ? 1 : -1; });
            }
            else {
                return [];
            }
        }
        var stations = [];
        for (var stationsNetwork in this.stations) {
            var _loop_4 = function (stationInNetwork) {
                if (!(stations.some(function (station) { return station.title == stationInNetwork.title; }))) {
                    stations.push(stationInNetwork);
                }
            };
            for (var _i = 0, _a = this.stations[stationsNetwork]; _i < _a.length; _i++) {
                var stationInNetwork = _a[_i];
                _loop_4(stationInNetwork);
            }
        }
        return stations.sort(function (a, b) { return (a.title > b.title) ? 1 : -1; });
    };
    TransferService.prototype.getStationByLatLng = function (latitude, longitude) {
        for (var _i = 0, _a = this.getStations(); _i < _a.length; _i++) {
            var station = _a[_i];
            if (station.latitude == latitude
                && station.longitude == longitude
                && station.type == Transfer_1.WaypointType.Station) {
                return station;
            }
        }
    };
    TransferService.prototype.getNetworkLatLngs = function (network) {
        if (network) {
            if (this.networkLatLngs[network])
                return this.networkLatLngs[network];
            return [];
        }
        var networkLatLngs = [];
        for (var key in this.networkLatLngs) {
            networkLatLngs = networkLatLngs.concat(this.networkLatLngs[key]);
        }
        return networkLatLngs;
    };
    TransferService.prototype.getNetworkLatLngsContext = function (network) {
        if (network) {
            if (this.networkLatLngsContext[network])
                return this.networkLatLngsContext[network];
            return [];
        }
        var networkLatLngsContext = [];
        for (var key in this.networkLatLngsContext) {
            networkLatLngsContext = networkLatLngsContext.concat(this.networkLatLngsContext[key]);
        }
        return networkLatLngsContext;
    };
    TransferService.prototype.getTransfer = function (name) {
        for (var _i = 0, _a = this.transfers; _i < _a.length; _i++) {
            var transfer = _a[_i];
            if (transfer.name == name)
                return transfer;
        }
    };
    TransferService.prototype.getTransfersByTitle = function (title) {
        var transfers = [];
        for (var _i = 0, _a = this.transfers; _i < _a.length; _i++) {
            var transfer = _a[_i];
            if (transfer.title == title) {
                transfers.push(transfer);
            }
        }
        return transfers;
    };
    TransferService.prototype.getTransfersByNormalizedTitle = function (title) {
        var _a = this.getTransferNormalizedTitle(title), normalizedTitle = _a.normalizedTitle, normalizedTitleSuffix = _a.normalizedTitleSuffix;
        var transfers = [];
        if (normalizedTitleSuffix) {
            for (var _i = 0, _b = this.transfers; _i < _b.length; _i++) {
                var transfer = _b[_i];
                if (transfer.titleNormalized == normalizedTitle
                    && transfer.titleSuffix == normalizedTitleSuffix) {
                    transfers.push(transfer);
                }
            }
        }
        else {
            for (var _c = 0, _d = this.transfers; _c < _d.length; _c++) {
                var transfer = _d[_c];
                if (transfer.titleNormalized == normalizedTitle
                    && !transfer.titleSuffix) {
                    transfers.push(transfer);
                }
            }
        }
        return transfers;
    };
    TransferService.prototype.getTransfersByDepartureStation = function (fromStation) {
        var transfers = [];
        for (var _i = 0, _a = this.transfers; _i < _a.length; _i++) {
            var transfer = _a[_i];
            var stationIndizes = [];
            // Get all station indizes for one way lookahead
            for (var i = 0; i < transfer.route.length; i++) {
                if (transfer.route[i].type == Transfer_1.WaypointType.Station)
                    stationIndizes.push(i);
            }
            // If it is a one way transfer, we need to look ahead if after the from-station there are other stations
            if (stationIndizes.length) {
                for (var i = 0; i < transfer.route.length; i++) {
                    if (transfer.isOneWay) {
                        if (transfer.route[i].type == Transfer_1.WaypointType.Station
                            && transfer.route[i].title == fromStation
                            && stationIndizes.indexOf(i) < (stationIndizes.length - 1)) {
                            transfers.push(transfer);
                            break;
                        }
                    }
                    else {
                        if (transfer.route[i].type == Transfer_1.WaypointType.Station
                            && transfer.route[i].title == fromStation) {
                            transfers.push(transfer);
                            break;
                        }
                    }
                }
            }
        }
        return transfers;
    };
    TransferService.prototype.getTransferTitleWithSuffix = function (transfer) {
        var transferTitle = transfer.title;
        var transferSuffix = transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix;
        return transferSuffix ? transferTitle + '_' + transferSuffix : transferTitle;
    };
    TransferService.prototype.combineTransferTitleWithSuffix = function (transferTitle, transferSuffix) {
        return transferSuffix ? transferTitle + '_' + transferSuffix : transferTitle;
    };
    TransferService.prototype.splitTransferTitleFromSuffix = function (titleWithSuffix) {
        var _a;
        var titleParts = titleWithSuffix.split('_');
        var title = titleParts[0];
        var titleSuffix = (_a = titleParts[1]) !== null && _a !== void 0 ? _a : '';
        return { title: title, titleSuffix: titleSuffix };
    };
    TransferService.prototype.getTransferNormalizedTitle = function (title) {
        var _a;
        var normalizedTitleParts = title.split('_');
        var normalizedTitle = normalizedTitleParts[0].replace(/–/g, '-').replace('/', '---').toLocaleLowerCase();
        var normalizedTitleSuffix = (_a = normalizedTitleParts[1]) !== null && _a !== void 0 ? _a : null;
        return {
            normalizedTitle: normalizedTitle,
            normalizedTitleSuffix: normalizedTitleSuffix,
        };
    };
    TransferService.prototype.getBaseTransfer = function (transfer) {
        if (transfer.baseTransferName)
            return this.getTransfer(transfer.baseTransferName);
        return transfer;
    };
    TransferService.prototype.getConnectionsFromTransfersByDepartureStation = function (transfersByFromStation, stationFrom, network) {
        var _a;
        var connections = [];
        transfersLoop: for (var _i = 0, transfersByFromStation_1 = transfersByFromStation; _i < transfersByFromStation_1.length; _i++) {
            var transfer = transfersByFromStation_1[_i];
            if (network && transfer.network != network)
                continue transfersLoop;
            connections = this.getConnectionsFromTransferByDepartureStation(transfer, stationFrom, connections);
        }
        combinationsLoop: for (var _b = 0, _c = this.combinations; _b < _c.length; _b++) {
            var combination = _c[_b];
            if (combination.from != stationFrom && combination.to != stationFrom)
                continue combinationsLoop;
            var connectionReverse = combination.from != stationFrom;
            var correctOrder = false;
            var from = (!connectionReverse) ? combination.from : combination.to;
            var to = (!connectionReverse) ? combination.to : combination.from;
            var transfers = [];
            var vias = [];
            for (var _d = 0, _e = combination.transfers; _d < _e.length; _d++) {
                var combinationTransfer = _e[_d];
                var transfer = this.getTransfer(combinationTransfer.name);
                if (!transfer) {
                    console.warn("Missing transfer [".concat(combinationTransfer.name, "] in combination:"), combination);
                    continue combinationsLoop;
                }
                else {
                    transfers.push(transfer);
                    if (combinationTransfer.via) {
                        vias.push(combinationTransfer.via);
                    }
                }
            }
            if (!transfers || !transfers[0]) {
                console.warn('Missing transfer or route in combination:', combination);
                continue combinationsLoop;
            }
            // Check for one way
            correctOrder = transfers[0].route.some(function (waypoint) {
                return waypoint.type == Transfer_1.WaypointType.Station && waypoint.title == stationFrom;
            });
            if (!correctOrder && combination.isOneWay)
                continue combinationsLoop;
            connections.push({
                stationFrom: from,
                stationTo: to,
                stationToSynonyms: this.synonyms[to] || [],
                transfers: !correctOrder ? transfers.reverse() : transfers,
                combinationReference: !correctOrder ? combination.transfers.slice().reverse() : combination.transfers,
                combinationName: combination.name,
                reversed: connectionReverse,
                via: (_a = combination.via) !== null && _a !== void 0 ? _a : vias.join(', '),
            });
        }
        return connections
            .sort(function (a, b) {
            if (a.stationTo > b.stationTo)
                return 1;
            if (a.stationTo < b.stationTo)
                return -1;
            if (a.via > b.via)
                return 1;
            if (a.via < b.via)
                return -1;
            return 0;
        });
    };
    TransferService.prototype.getConnectionsFromTransferByDepartureStation = function (transfer, stationFrom, connections) {
        if (connections === void 0) { connections = []; }
        var stationFromIndex = 0;
        // Check if it is one way and NOT a circle route like "Salzburg-Trieste-Graz-Salzburg"
        if (transfer.isOneWay && transfer.route[0].title != transfer.route[transfer.route.length - 1].title) {
            for (var i = 0; i < transfer.route.length; i++) {
                if (transfer.route[i].type == Transfer_1.WaypointType.Station && transfer.route[i].title == stationFrom) {
                    stationFromIndex = i;
                }
            }
        }
        // If it is one way we start iterating at the from-station
        routeLoop: for (var i = stationFromIndex; i < transfer.route.length; i++) {
            var waypoint = transfer.route[i];
            if (waypoint.type != Transfer_1.WaypointType.Station)
                continue routeLoop; // Only Stations, next waypoint
            if (stationFrom == waypoint.title)
                continue routeLoop; // Going to the same station is not possible, next waypoint
            // Check if connection with transfer is already in the data array to avoid duplicated values in to-field.
            connectionsLoop: for (var _i = 0, connections_1 = connections; _i < connections_1.length; _i++) {
                var connection = connections_1[_i];
                if (connection.stationFrom == stationFrom
                    && connection.stationTo == waypoint.title
                    && connection.transfers[0].title == transfer.title
                    && connection.transfers[0].network == transfer.network) {
                    // IF NEEDED Loop over all transfers and check if transfer is already added, can happen for routes like "Salzburg-Trieste-Graz-Salzburg" and don't add, just continue. This is just to reduce drawings on map.
                    // It is possible that a connection has multiple routes like "Rotterdam - Wolfurt" so we push all transfers and later draw them
                    connection.transfers.push(transfer);
                    continue routeLoop;
                }
            }
            connections.push({
                stationFrom: stationFrom,
                stationTo: waypoint.title,
                stationToSynonyms: this.synonyms[waypoint.title] || [],
                transfers: [transfer],
            });
        }
        return connections;
    };
    TransferService.prototype.getCombination = function (name) {
        for (var _i = 0, _a = this.combinations; _i < _a.length; _i++) {
            var combination = _a[_i];
            if (combination.name == name)
                return combination;
        }
    };
    TransferService.prototype.getLocation = function (name) {
        for (var _i = 0, _a = this.locations; _i < _a.length; _i++) {
            var location_2 = _a[_i];
            if (location_2.name == name)
                return location_2;
        }
    };
    TransferService.prototype.getLocationByLatLng = function (latitude, longitude) {
        for (var _i = 0, _a = this.locationsGrouped; _i < _a.length; _i++) {
            var location_3 = _a[_i];
            if (location_3.latitude == latitude && location_3.longitude == longitude)
                return location_3;
        }
    };
    TransferService.prototype.getLocations = function () {
        return this.locations;
    };
    TransferService.prototype.getLocationsGroupedByLatLng = function () {
        return this.locationsGrouped;
    };
    TransferService.prototype.getIndividuals = function () {
        return this.individuals;
    };
    TransferService.prototype.getI18nStrings = function () {
        return this.i18nStrings;
    };
    TransferService.prototype.getLocale = function () {
        return this.locale;
    };
    TransferService.prototype.getMatchingChargeFromTransfers = function (transfers) {
        var charge = {};
        for (var _i = 0, transfers_1 = transfers; _i < transfers_1.length; _i++) {
            var connectionTransfer = transfers_1[_i];
            var connectionBaseTransfer = connectionTransfer.baseTransferName
                ? this.getTransfer(connectionTransfer.baseTransferName)
                : connectionTransfer;
            if (connectionBaseTransfer.charge) {
                for (var _a = 0, _b = connectionBaseTransfer.charge; _a < _b.length; _a++) {
                    var connectionTranferCharge = _b[_a];
                    if (!charge[connectionTranferCharge])
                        charge[connectionTranferCharge] = 0;
                    charge[connectionTranferCharge]++;
                }
            }
        }
        for (var key in charge) {
            if (charge[key] !== transfers.length) {
                delete charge[key];
            }
        }
        return Object.keys(charge);
    };
    TransferService.prototype.getPossibleChargeFromTransfers = function (transfers) {
        var possibleCharge = [];
        for (var _i = 0, transfers_2 = transfers; _i < transfers_2.length; _i++) {
            var transfer = transfers_2[_i];
            if (!transfer.charge)
                continue;
            for (var _a = 0, _b = transfer.charge; _a < _b.length; _a++) {
                var charge = _b[_a];
                if (possibleCharge.indexOf(charge) === -1)
                    possibleCharge.push(charge);
            }
        }
        return possibleCharge;
    };
    TransferService.prototype.getPossibleChargeFromTransfersByNetwork = function (network) {
        var transfersInNetwork = this.getTransfersByNetwork(network);
        return this.getPossibleChargeFromTransfers(transfersInNetwork);
    };
    TransferService.prototype.sortCharge = function (charge) {
        var _this = this;
        return charge.sort(function (a, b) {
            if (_this.chargeSortOrder.indexOf(a) > _this.chargeSortOrder.indexOf(b)) {
                return 1;
            }
            else {
                return -1;
            }
        });
    };
    return TransferService;
}());
exports.TransferService = TransferService;
